import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { ShieldCheck, Bell, Pencil } from "lucide-react";

export default function AdminBanner() {
  const { user } = useAuth();
  const location = useLocation();
  const [pending, setPending] = useState(0);
  const [notif, setNotif] = useState(0);

  useEffect(() => {
    if (user?.role !== "admin") return;
    const fetchCounts = async () => {
      try {
        const [p, n] = await Promise.all([
          api.get("/admin/pending-count"),
          api.get("/admin/notifications/pending-count"),
        ]);
        setPending(p.data.count || 0);
        setNotif(n.data.count || 0);
      } catch { /* ignore */ }
    };
    fetchCounts();
    const t = setInterval(fetchCounts, 30000);
    return () => clearInterval(t);
  }, [user?.role]);

  if (user?.role !== "admin") return null;
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <div className="bg-[#2DD4BF] text-[#05070C] border-b border-[#14B8A6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-2 flex items-center gap-3 flex-wrap text-xs md:text-sm">
        <ShieldCheck className="h-4 w-4" />
        <span className="font-semibold uppercase tracking-wider">Admin Mode</span>
        <span className="opacity-70 hidden sm:inline">— You own this site, {user.name?.split(" ")[0]}</span>
        <div className="flex-1" />
        {pending > 0 && (
          <Link to="/admin" className="inline-flex items-center gap-1 bg-[#05070C]/20 hover:bg-[#05070C]/30 rounded-full px-3 py-1 font-medium">
            <Bell className="h-3 w-3" /> {pending} expert{pending !== 1 ? "s" : ""} waiting to verify
          </Link>
        )}
        {notif > 0 && (
          <Link to="/admin?tab=notifications" className="inline-flex items-center gap-1 bg-[#05070C]/20 hover:bg-[#05070C]/30 rounded-full px-3 py-1 font-medium">
            {notif} welcome msg pending
          </Link>
        )}
        <Link to="/admin" className="inline-flex items-center gap-1 bg-[#05070C] hover:bg-[#0F1B33] text-[#2DD4BF] rounded-full px-3 py-1 font-medium">
          <Pencil className="h-3 w-3" /> Admin Panel
        </Link>
      </div>
    </div>
  );
}
